/** The preview is only needed on Settings > Appearance: keep it out of the main chunk. */
import { lazy } from 'react';

export const ModePreviewLazy = lazy(() =>
  import('./ModePreview.js').then((m) => ({ default: m.ModePreview })),
);
